<template>
  <div>
    <div class="form-container">
      <div class="tools">
        <form-button @click="$emit('check')">返回</form-button>
        <form-button @click="confrimCheck">确认对账</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="110px"
        :model="conditions"
      >
        <common-title title="基本信息" />

        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="对账单号">
              <el-input
                v-model="conditions.checkBillNo"
                placeholder="自动生成"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="操作人">
              <el-input v-model="conditions.createdByName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="结算日期">
              <el-input
                v-model="conditions.createdDate"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="对账周期起">
              <el-input
                v-model="conditions.startday"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="对账周期止">
              <el-input
                v-model="conditions.endday"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="对账分仓">
              <el-select v-model="conditions.warehouse" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['Warehouse']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编码">
              <wly-input
                v-model="conditions.customerCode"
                input-type="customer"
                clearable
                @enter="handleEnter"
                @handleSuffixClick="showDialog = true"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input v-model="conditions.customerName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="明细" :custome-config="() => vxeShowCustom('gridOptions')">
        <template #button>
          <table-button name="add" tip="物流异常处理" @click="toHandle" />
          <table-button name="export" tip="导出" @click="exportExcel" />
        </template>
        <vxe-grid
          ref="gridOptions"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :row-style="rowStyle"
          @filter-change="filterChange"
        >
          <template #orderStatus="{ row }">
            {{ filterDictionary(row.orderStatus, 'B0101') }}
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="客户选择"
      width="70%"
    >
      <client-select v-if="showDialog" ref="clientSelect" mode="RELATION" />
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiFindDeliveryCheckoutGenerate, apiAddReconciliation } from '@/api/applyForGoods/logisticsAbnormal'
import ClientSelect from '@/components/dialog/ClientSelect'
import { frontExport } from '@/utils/frontExport'
import { filterDictionary } from '@/utils/index'
export default {
  components: {
    ClientSelect
  },
  props: {
    params: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      selectDataOptions: {},
      showDialog: false,
      conditions: {
        checkBillNo: '',
        comment: '',
        createdByName: '',
        endday: '',
        startday: '',
        warehouse: '',
        customerCode: '',
        customerName: ''
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 30 },
          { title: '发货单号', field: 'wantCode', filters: [], filterMultiple: false, width: 110 },
          { title: '客户名称', field: 'customerName', filters: [], filterMultiple: false, width: 200 },
          { title: '产品名称', field: 'productDesc', filters: [], filterMultiple: false, width: 260 },
          { title: '申请时间', field: 'createdDate', filters: [], filterMultiple: false, width: 140 },
          { title: '申请发货量', field: 'wantQuantity', width: 100 },
          { title: '接收24小时是否反馈', field: 'feedbackOntime', width: 90, formatter: ({ cellValue }) => cellValue == 1 ? '是' : '否' },
          { title: '接收时间', field: 'receiptDate', width: 140 },
          { title: '应到货时间', field: 'shouldArrivedate', width: 140 },
         // { title: '派车时间', field: 'assignCarTime', width: 140 },
          { title: '发运时间', field: 'shipTime', width: 140 },
          { title: '到货时间', field: 'reachedTime', width: 140 },
          { title: '签收时间', field: 'signDate', width: 140 },
          { title: '接收数量', field: 'actDeliveryQty', width: 90 },
          { title: '发货仓库', field: 'warehouseOut', width: 100 },
          { title: '运单号', field: 'logisticno', width: 110 },
          //{ title: '订单状态', field: 'orderStatus', width: 80, slots: { default: 'orderStatus' }},
          { title: '备注', field: 'comment', width: 150 }
        ],
        data: []
      }
    }
  },
  watch: {
    'conditions.customerName': {
      handler() {
        this.init()
      }
    },
    'conditions.warehouse': {
      handler() {
        this.init()
      }
    }
  },
  activated() {
    this.init()
  },
  created() {
    Object.assign(this.conditions, this.params)
    this.getSelectDictDataOrigin('Warehouse')
    this.getSelectDictDataOrigin('B0101')
  },
  mounted() {
    this.init()
  },
  methods: {
    filterDictionary,
    rowStyle({ row }) {
      if (row.signDate && row.shouldArrivedate) {
        const date1 = new Date(row.signDate).getTime()
        const date2 = new Date(row.shouldArrivedate).getTime()

        if (date1 > date2) {
          return {
            background: '#f17373'
          }
        }
        return
      }
      return
    },
    async init() {
      const { data } = await apiFindDeliveryCheckoutGenerate(this.conditions)
      this.setColumnsFilters(data)
      this.gridOptions.data = data
    },
    exportExcel() {
      const { tableData } = this.$refs.gridOptions.getTableData()
      frontExport(this.gridOptions.columns, tableData, '发货对账明细')
    },
    toHandle() {
      const checkData = this.$refs.gridOptions.getCheckboxRecords()
      if (!checkData.length) {
        return this.$message.warning('请选择有效数据！')
      }
      // localStorage.setItem('wly_abnormal', JSON.stringify(checkData))
      setTimeout(() => {
        this.$router.push({
          path: '/wly/to-goods/business-processing/logistics-exceptionhandling',
          query: {
            mode: 'local',
            ids: checkData.map(v => v.wantCode).join(',')
          }
        })
      })
    },
    confrimCheck() {
      const checkData = this.$refs.gridOptions.getCheckboxRecords()

      if (!checkData.length) {
        return this.$message.warning('请选择要对账的要货明细！')
      }

      this.$confirm('是否真的要进行发货对账处理?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async res => {
        const params = {
          ...this.conditions,
          reconciliationDTOList: checkData
        }
        const result = await apiAddReconciliation(params)
        if (result.status === 1) {
          this.$message.success('操作成功！')
          this.$router.replace('/wly/to-goods/data-searching/delivery-check-search')
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      this.conditions.customerCode = data.partner
      this.conditions.customerName = data.name_org1
    },
    async handleSubmit() {
      const data = await this.$refs.clientSelect.submitForm()
      if (!data) return

      this.conditions.customerCode = data.partner
      this.conditions.customerName = data.name_org1
      this.showDialog = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    filterChange(params) {
      console.log(params)
      const { filters } = params
      const { tableData } = this.$refs.gridOptions.getTableData()

      // 需要重新设置其他未选中的过滤数据
      this.setColumnsFilters(tableData, (xTable, field, data) => {
        const ftInfo = filters.find(item => item.property === field)

        const column = xTable.getColumnByField(field)
        const data2 = data.map(item => {
          return {
            label: item,
            value: item,
            checked: item === ftInfo?.values[0]
          }
        })
        xTable.setFilter(column, data2)
        xTable.updateData()
      })
    },
    /**
     * 设置表格过滤
     * @params {object} data 表格数据
     * @params {function} cb 自定义设置
     */
    setColumnsFilters(data, cb = undefined) {
      const xTable = this.$refs.gridOptions
      // 需要设置过滤的字段
      const filterFields = ['wantCode', 'customerName', 'productDesc', 'wantDate']
      filterFields.forEach(field => {
        const filterData = Array.from(new Set(data.map(item => item[field])))
        if (cb) {
          // 自定义设置回调函数
          cb(xTable, field, filterData)
        } else {
          this.setFilters(xTable, field, filterData)
        }
      })
    },
    /**
     * 设置过滤列
     * @params {object} xTable 表格refs
     * @params {string} field 需要设置过滤的表格字段
     * @params {array} data 过滤列的数据
     */
    setFilters(xTable, field, data) {
      const column = xTable.getColumnByField(field)
      const data2 = data.map(item => {
        return {
          label: item,
          value: item
        }
      })
      xTable.setFilter(column, data2)
      // 修改条件之后，需要手动调用 updateData 处理表格数据
      // xTable.updateData()
    }
  }
}
</script>

<style>
.timeout{
  background: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/DeliverCheckStep2.vue